export enum VoucherRefundStatusEnum {
	Pending = 1,
	Applied = 2,
}
